var _style, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 320 52.41"
    },
    viewBox: "0 0 320 52.41",
    className: "h-5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".gr4{fill:#f9ba0a}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "grSVGID_1_",
    d: "M267.59 0H320v52.41h-52.41z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "grSVGID_00000158717599949911643880000006578562922510213512_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#grSVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M319.49 21.07h-2.11v-.11H293.8v10.48h14.81c-2.17 6.1-7.97 10.48-14.81 10.48-8.69 0-15.72-7.04-15.72-15.72 0-8.69 7.04-15.72 15.72-15.72 4.01 0 7.66 1.51 10.43 3.98l7.41-7.41C306.96 2.69 300.7 0 293.8 0c-14.47 0-26.2 11.73-26.2 26.2 0 14.47 11.73 26.2 26.2 26.2 14.47 0 26.2-11.73 26.2-26.2 0-1.75-.18-3.47-.51-5.13zm0 0",
    style: {
      clipPath: "url(#grSVGID_00000158717599949911643880000006578562922510213512_)",
      fill: "#fbbf0d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.61 14.01 8.61 6.32c2.33-5.77 7.97-9.84 14.57-9.84 4.01 0 7.66 1.51 10.43 3.98l7.41-7.41C306.96 2.69 300.7 0 293.8 0c-10.07 0-18.8 5.68-23.19 14.01zm0 0",
    style: {
      clipPath: "url(#grSVGID_00000158717599949911643880000006578562922510213512_)",
      fill: "#e7441e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.8 52.41c6.77 0 12.92-2.59 17.57-6.8l-8.11-6.86c-2.63 1.99-5.9 3.18-9.46 3.18-6.82 0-12.6-4.34-14.78-10.41l-8.55 6.58c4.33 8.48 13.14 14.31 23.33 14.31zm0 0",
    style: {
      clipPath: "url(#grSVGID_00000158717599949911643880000006578562922510213512_)",
      fill: "#4cae50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.49 21.07h-2.11v-.11H293.8v10.48h14.81a15.816 15.816 0 0 1-5.36 7.3h.01l8.11 6.86c-.57.52 8.63-6.3 8.63-19.4 0-1.75-.18-3.47-.51-5.13zm0 0",
    style: {
      clipPath: "url(#grSVGID_00000158717599949911643880000006578562922510213512_)",
      fill: "#2e72b7"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7 21.14 30.88 31.18l5.31 16.31-13.84-10.07L8.48 47.49l5.31-16.31L0 21.14h17.04l5.31-16.22 5.28 16.22H44.7zM93.2 21.14 79.38 31.18l5.31 16.31-13.84-10.07-13.88 10.07 5.31-16.31L48.5 21.14h17.04l5.31-16.22 5.28 16.22H93.2zM141.7 21.14l-13.82 10.04 5.31 16.31-13.84-10.07-13.87 10.07 5.31-16.31L97 21.14h17.04l5.31-16.22 5.28 16.22h17.07zM190.19 21.14l-13.82 10.04 5.31 16.31-13.84-10.07-13.87 10.07 5.31-16.31-13.78-10.04h17.04l5.31-16.22 5.28 16.22h17.06zM238.69 21.14l-13.82 10.04 5.31 16.31-13.84-10.07-13.87 10.07 5.31-16.31L194 21.14h17.04l5.31-16.22 5.28 16.22h17.06z",
    className: "gr4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleRating);
export default __webpack_public_path__ + "static/media/google-rating.5c203b890762c63153a108150fd5da9e.svg";
export { ForwardRef as ReactComponent };